// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.directory {
  color: aliceblue;
  text-align: left;
  font-size: 13px;
  margin-bottom: 15px;
}
.BuildingDetailsImageHolder{
  cursor: pointer;
}

.BuildingDetailsImageHolder .mui-image-wrapper{
  height: auto !important;
}
.cancelUPdateBuilding{
  border-radius: 0 !important;
  float: right !important;
  background-color: #4d535c !important;
}
.formContainer{
  width: 98% !important;
}

.formContainer textarea{
  height: 100% !important;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;

}
.BuildingDetailsImageHolder{
  height: 100%;
}

.BuildingDetailsImageHolder:hover{
  border: 1px solid #858282;
}

.started {
  color: #fff;
  text-align: left;
}
.homeContainerBuilding .MuiTooltip-popper[data-popper-placement*="bottom"] .css-ja5taz-MuiTooltip-tooltip{
  background-color: #1e2024 !important;
  border: none !important;
  border-radius: 0 !important;
}

.homeContainerBuilding .MuiTooltip-popper[data-popper-placement*="bottom"] .css-ja5taz-MuiTooltip-tooltip button{
  color: #fff !important;
  margin: 5px;
  border-radius: 0 !important;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    font-size: small;
}

.homeContainerBuilding .MuiTooltip-popper[data-popper-placement*="bottom"] .css-ja5taz-MuiTooltip-tooltip button:hover{
  background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}

.buildImageBuilding {
  background-color: #282b30;
  width: 100%;
  height: fit-content;
  padding: 10px;
}
.buildImageBuilding image {
  width: 100% !important;
}
.addButton button{
  border-radius: 0 !important;

}
.cancelButton button{
  width: fit-content !important;
}

.deleteButtonBuilding {
  text-align: left;
}
.BuildingDetailsImageHolder .mui-image-wrapper img{
  object-fit: fill !important;
  cursor: pointer;
}
.map-container-archilogic{
  min-height: 200px;
  height: 100vh !important;
  width: 100%;
}
.css-1ex1afd-MuiTableCell-root:last-child{
  width: 30px !important;
}
.css-1ex1afd-MuiTableCell-root:nth-child(4){
  width:auto !important;

}

.deleteButtonBuilding button {
  height: 35px !important;
  margin-top: 15px;
  width: 220px;
  text-align: center;
  background-color: #777a84;
  color: #fff;
}
.deleteButtonBuilding button:hover {
  background-color: #777a84;
}

.circle {
    position: relative;
    background-color: #e16162;
    border-radius: 50%;
    color: #fff;
    display: flex;
    font-size: 20px;
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
  
    font-weight: bold;
    transition: margin-left 1s;
}

.monitor {
  margin-top: 10px;
  display: flex;
}

.monitor button {
  position: relative;
  font-size: 12px;
  height: 30px;
  width: 130px;
  background-color: #e16162;
}

.info {
  margin-left: 20px;
  background-color: #282b30;
  padding: 20px;
}

.assets {

  margin-left: 20px;
  margin-top: 20px;
  height: auto;
  background-color: #282b30;
  padding: 20px;
}

.floors {
  width: 80%;
  height: 40%;
  background-color: #282b30;
  margin-top: 20px;
  padding: 20px;
  margin-left: 50px;
}

.infoTitle {
  margin: 0 !important;
  text-align: left !important;
  color: #fff;
  left: 0; /* <--------------------- required */
  top: 0;
}
.infoTitle h2 {
  margin: 0 !important;
}
.infoButton {
  text-align: right;
  top: 0; /* <---------------------- required */
  right: 0;
}

.infoButton button {
  font-size: 10px;
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
}
.infoButton button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}
.description {
  margin-left: 10px;
  margin-top: 20px;
  width: 95%;
  height: fit-content;
  background-color: #1e2024;
  padding: 10px;
  text-align: left;
  color: #fff;
}
.floors .css-177gid-MuiTableCell-root {
  text-align: left !important;
  color: #fff !important;
  border-bottom: none !important;
  border-left: 3px solid #4996ee;
  padding: 6px !important;
}
.floors .css-1azl6jz-MuiTableCell-root {
  text-align: left !important;
  color: #fff !important;
  border-bottom: none !important;
}
.floors .css-rqglhn-MuiTable-root {
  width: auto !important;
  background-color: #282b30 !important;
  color: #fff !important;
}
.floors .css-11xur9t-MuiPaper-root-MuiTableContainer-root {
  width: auto !important;
  background-color: #282b30 !important;
  color: #fff !important;
  box-shadow: none !important;
}
.floors .mui-image-wrapper {
  width: auto !important;
}

@media only screen and (max-width: 1180px) and (min-width: 980px) {
  
  .floors {
    width: 80%;
    height: 40%;
    background-color: #282b30;
    margin-left: 80px;
  }
}

@media only screen and (max-width: 980px) and (min-width: 900px) {
  .info {
   
    height: 50%;
  }
  .floors {
    width: 70%;
    height: 40%;
    background-color: #282b30;
    margin-left: 120px;
  }
}

@media only screen and (max-width: 900px) {
  .info {
margin-left: 0;
    margin-top: 20px;


  }
  .floors {
    width: 90%;
    height: 40%;
    background-color: #282b30;
    margin-top: 20px;
    margin-left: 0;
  }
  .buildImage {
    background-color: #282b30;
    width: auto;
    height: auto;
    padding: 10px;
  }

  .homeContainerBuilding .map-container{
    height: 100vh !important;
  }
  

  .assets {

    margin-left: 0;
 
  }
}

.fullscreenButton{
  position: relative;
  float: right;
  margin-bottom: -42px;
  color: black !important;
  z-index: 1000;
  cursor: pointer;
}


.map-container{
  height: 100% 
}

.full-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index:1
}`, "",{"version":3,"sources":["webpack://./src/pages/BuildingDetail/BuildingDetail.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;;AAEtC;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,2BAA2B;IACzB,iFAAiF;IACjF,gBAAgB;AACpB;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;;AAE7B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;;AAEvB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;;IAEnB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;EACX,OAAO,EAAE,oCAAoC;EAC7C,MAAM;AACR;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,MAAM,EAAE,qCAAqC;EAC7C,QAAQ;AACV;;AAEA;EACE,eAAe;EACf;;;;GAIC;AACH;AACA;EACE;;;;GAIC;AACH;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;;AAEA;;EAEE;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA;EACE;AACF,cAAc;IACV,gBAAgB;;;EAGlB;EACA;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;;EAGA;;IAEE,cAAc;;EAEhB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;;AAGA;EACE;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;AACF","sourcesContent":[".directory {\n  color: aliceblue;\n  text-align: left;\n  font-size: 13px;\n  margin-bottom: 15px;\n}\n.BuildingDetailsImageHolder{\n  cursor: pointer;\n}\n\n.BuildingDetailsImageHolder .mui-image-wrapper{\n  height: auto !important;\n}\n.cancelUPdateBuilding{\n  border-radius: 0 !important;\n  float: right !important;\n  background-color: #4d535c !important;\n}\n.formContainer{\n  width: 98% !important;\n}\n\n.formContainer textarea{\n  height: 100% !important;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n\n}\n.BuildingDetailsImageHolder{\n  height: 100%;\n}\n\n.BuildingDetailsImageHolder:hover{\n  border: 1px solid #858282;\n}\n\n.started {\n  color: #fff;\n  text-align: left;\n}\n.homeContainerBuilding .MuiTooltip-popper[data-popper-placement*=\"bottom\"] .css-ja5taz-MuiTooltip-tooltip{\n  background-color: #1e2024 !important;\n  border: none !important;\n  border-radius: 0 !important;\n}\n\n.homeContainerBuilding .MuiTooltip-popper[data-popper-placement*=\"bottom\"] .css-ja5taz-MuiTooltip-tooltip button{\n  color: #fff !important;\n  margin: 5px;\n  border-radius: 0 !important;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    font-size: small;\n}\n\n.homeContainerBuilding .MuiTooltip-popper[data-popper-placement*=\"bottom\"] .css-ja5taz-MuiTooltip-tooltip button:hover{\n  background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n\n.buildImageBuilding {\n  background-color: #282b30;\n  width: 100%;\n  height: fit-content;\n  padding: 10px;\n}\n.buildImageBuilding image {\n  width: 100% !important;\n}\n.addButton button{\n  border-radius: 0 !important;\n\n}\n.cancelButton button{\n  width: fit-content !important;\n}\n\n.deleteButtonBuilding {\n  text-align: left;\n}\n.BuildingDetailsImageHolder .mui-image-wrapper img{\n  object-fit: fill !important;\n  cursor: pointer;\n}\n.map-container-archilogic{\n  min-height: 200px;\n  height: 100vh !important;\n  width: 100%;\n}\n.css-1ex1afd-MuiTableCell-root:last-child{\n  width: 30px !important;\n}\n.css-1ex1afd-MuiTableCell-root:nth-child(4){\n  width:auto !important;\n\n}\n\n.deleteButtonBuilding button {\n  height: 35px !important;\n  margin-top: 15px;\n  width: 220px;\n  text-align: center;\n  background-color: #777a84;\n  color: #fff;\n}\n.deleteButtonBuilding button:hover {\n  background-color: #777a84;\n}\n\n.circle {\n    position: relative;\n    background-color: #e16162;\n    border-radius: 50%;\n    color: #fff;\n    display: flex;\n    font-size: 20px;\n    width: 30px;\n    height: 30px;\n    justify-content: center;\n    align-items: center;\n  \n    font-weight: bold;\n    transition: margin-left 1s;\n}\n\n.monitor {\n  margin-top: 10px;\n  display: flex;\n}\n\n.monitor button {\n  position: relative;\n  font-size: 12px;\n  height: 30px;\n  width: 130px;\n  background-color: #e16162;\n}\n\n.info {\n  margin-left: 20px;\n  background-color: #282b30;\n  padding: 20px;\n}\n\n.assets {\n\n  margin-left: 20px;\n  margin-top: 20px;\n  height: auto;\n  background-color: #282b30;\n  padding: 20px;\n}\n\n.floors {\n  width: 80%;\n  height: 40%;\n  background-color: #282b30;\n  margin-top: 20px;\n  padding: 20px;\n  margin-left: 50px;\n}\n\n.infoTitle {\n  margin: 0 !important;\n  text-align: left !important;\n  color: #fff;\n  left: 0; /* <--------------------- required */\n  top: 0;\n}\n.infoTitle h2 {\n  margin: 0 !important;\n}\n.infoButton {\n  text-align: right;\n  top: 0; /* <---------------------- required */\n  right: 0;\n}\n\n.infoButton button {\n  font-size: 10px;\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n}\n.infoButton button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n.description {\n  margin-left: 10px;\n  margin-top: 20px;\n  width: 95%;\n  height: fit-content;\n  background-color: #1e2024;\n  padding: 10px;\n  text-align: left;\n  color: #fff;\n}\n.floors .css-177gid-MuiTableCell-root {\n  text-align: left !important;\n  color: #fff !important;\n  border-bottom: none !important;\n  border-left: 3px solid #4996ee;\n  padding: 6px !important;\n}\n.floors .css-1azl6jz-MuiTableCell-root {\n  text-align: left !important;\n  color: #fff !important;\n  border-bottom: none !important;\n}\n.floors .css-rqglhn-MuiTable-root {\n  width: auto !important;\n  background-color: #282b30 !important;\n  color: #fff !important;\n}\n.floors .css-11xur9t-MuiPaper-root-MuiTableContainer-root {\n  width: auto !important;\n  background-color: #282b30 !important;\n  color: #fff !important;\n  box-shadow: none !important;\n}\n.floors .mui-image-wrapper {\n  width: auto !important;\n}\n\n@media only screen and (max-width: 1180px) and (min-width: 980px) {\n  \n  .floors {\n    width: 80%;\n    height: 40%;\n    background-color: #282b30;\n    margin-left: 80px;\n  }\n}\n\n@media only screen and (max-width: 980px) and (min-width: 900px) {\n  .info {\n   \n    height: 50%;\n  }\n  .floors {\n    width: 70%;\n    height: 40%;\n    background-color: #282b30;\n    margin-left: 120px;\n  }\n}\n\n@media only screen and (max-width: 900px) {\n  .info {\nmargin-left: 0;\n    margin-top: 20px;\n\n\n  }\n  .floors {\n    width: 90%;\n    height: 40%;\n    background-color: #282b30;\n    margin-top: 20px;\n    margin-left: 0;\n  }\n  .buildImage {\n    background-color: #282b30;\n    width: auto;\n    height: auto;\n    padding: 10px;\n  }\n\n  .homeContainerBuilding .map-container{\n    height: 100vh !important;\n  }\n  \n\n  .assets {\n\n    margin-left: 0;\n \n  }\n}\n\n.fullscreenButton{\n  position: relative;\n  float: right;\n  margin-bottom: -42px;\n  color: black !important;\n  z-index: 1000;\n  cursor: pointer;\n}\n\n\n.map-container{\n  height: 100% \n}\n\n.full-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index:1\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
